export const GET_CAMPAIGN_APPROVAL_DATA = 'GET_CAMPAIGN_APPROVAL_DATA';
export const GET_CAMPAIGN_ASSETS_DATA = 'GET_CAMPAIGN_ASSETS_DATA';
